export var uuid = function (length) {
    if (length === void 0) { length = 16; }
    var s = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var max = s.length;
    var res = '';
    var i = 0;
    for (; i < length; i++) {
        var ran = Math.floor(Math.random() * max);
        res += s[ran];
    }
    return res;
};
